<template>
  <header class="header">
    <div class="header-burger" @click="$emit('toggleMenu')">
      <svg class="svg-sprite-icon svg-sprite-unstyled icon-burger">
        <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#burger"></use>
      </svg>
    </div>
    <a class="logo mr-auto" href="/">
      <svg class="svg-sprite-icon svg-sprite-colorized icon-logo">
        <use xlink:href="@/assets/img/svg/symbol/symbol_color.svg#logo"></use>
      </svg>
    </a>
    <div class="account">
      <div class="account--inner" v-if="showReload">
        <button class="btn btn-refresh" @click="reload">
          <svg class="svg-sprite-icon svg-sprite-unstyled icon-refresh">
            <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#refresh"></use>
          </svg>
          Обновить
        </button>
      </div>
    </div>

  </header>
</template>
<script>
export default {
  name: 'right-header',
  props: {
    showReload: {},
  },
  methods: {
    reload() {
      this.$reload();
    }
  }
}
</script>
<style lang="scss" scoped>
.mr-auto {
  margin-right: auto;
}

.header-burger {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  cursor: pointer;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-burger .svg-sprite-icon {
  stroke: #000;
  fill: transparent;
  width: 21px;
  height: 25px;
}
</style>
